import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import Spinner from "../../Components/Spinner";
import ErrorMessage from "../../Components/ErrorMessage";
import { useParams } from "react-router-dom";
import { useLanguage } from "../../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const DisconnectCustomMcpModal = ({
    account_id,
    userData,
    show,
    handleClose,
    selectedMCP,
    fetchData
}) => {
    const {t} = useLanguage()
    const { org_id } = useParams()
    const [loadingSave, setLoadingSave] = useState(false);
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });

    useEffect(() => {
        if (!show) {
            setErrorMessage({ message: "", display: false });
        }
    }, [show]);

    const closeModal = () => {
        handleClose();
        setErrorMessage({ message: "", display: false });
        setLoadingSave(false);
    };

    const handleDisconnect = async () => {
        setLoadingSave(true)
        const redirect_uri = window.location.origin;
        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/disconnect_custom_mcp`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    account_id,
                    email: userData.email,
                    mcp_id: selectedMCP.id,
                    redirect_uri
                }),
            });
            const result = await response.json();
            setLoadingSave(false)

            if (result.status == "success") {
                closeModal()
                fetchData(org_id)
            }
        } catch (err) {
            setErrorMessage({ message: t.error_occurred, display: true });
            console.error("OAuth Error:", err);
        }
        return;
    };

    return (
        <Modal show={show} centered onHide={closeModal} size="md">
            <div className="modal_header">
                <p className="modal_header_title">
                    {t.disconnect} {selectedMCP?.name}
                </p>
            </div>

            <div className="modal_main_cont">
                <div className="warning_message_cont">
                    <p className="warning_message_title">{t.disconnect} {selectedMCP?.name}?</p>
                    <p className="warning_message_description">
                        {t.abilities.disconnect_mex}
                    </p>
                </div>
            </div>

            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_save_btn"
                        disabled={loadingSave}
                        onClick={handleDisconnect}
                    >
                        {loadingSave ? <Spinner loading={true} /> : t.disconnect}
                    </button>

                    <button
                        className="modale_close_btn"
                        onClick={closeModal}
                        disabled={loadingSave}
                    >
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default DisconnectCustomMcpModal;